import React, { Component, useEffect, useState } from 'react';
import SettingsView from './SettingsView';
import crmservices from '../../wsclient/';
import { getAppCfg, getData, getLanguage, logOut, saveDataIntoAsyncStore } from '../../utils/common';
import i18n from '../../translations/i18n'
import Loading from '../../components/Loading';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { useTranslation } from 'react-i18next';
import ModalConfirm from '../../components/ModalConfirm';
import ModalAlert from '../../components/ModalAlert';

function SettingsController(props) {
    const { t } = useTranslation();

    const [showLoading, onShowLoading] = useState(false);
    const [currentLanguge, setCurrentLanguage] = useState(getLanguage("LANGUAGE"));
    const [sms_opt_out, setSmsOtpOut] = useState(false);
    const [email_opt_out, setEmailOtpOut] = useState(false);
    const [enable_switch, setEnableSwitch] = useState({
        email_opt_out: true,
        sms_opt_out: true,
        language: true
    });
    const [confirm, setConfirm] = useState({});
    const [error, setError] = useState({
        showAlert: false,
        close: true,
        message: '',
        status: '',
    });
    const [languages, setLanguages] = useState(getData('LANGUAGES') ? JSON.parse(getData('LANGUAGES')) : [])

    const app_config = getAppCfg()
    const app_name = app_config && app_config.name ? app_config.name : null;

    useEffect(() => {
        onLoadContact();
    }, [])

    const onUpdateMarketingInformation = async (type, status) => {
        if (!enable_switch[type]) {
            return;
        }
        setEnableSwitch(prevState => ({
            ...prevState,
            [type]: false
        }))
        if (type == 'email_opt_out') {
            setEmailOtpOut(status);
        }
        else if (type == 'sms_opt_out') {
            setSmsOtpOut(status);
        }
        try {
            await crmservices.contacts.updateContactConsents({ [type]: !status });
            try {
                let result = await crmservices.contacts.getContact();
                if (result.code === 'OK') {
                    let sms_opt_out = result.data.sms_opt_out ? false : true;
                    let email_opt_out = result.data.email_opt_out ? false : true;
                    setSmsOtpOut(sms_opt_out);
                    setEmailOtpOut(email_opt_out);
                    //await cache.setContact(result.data);
                }
            } catch (error) {
                console.log("load contact error:", error);
            }
        } catch (error) {
            console.log("on receive marketing exeption:", error);
        }
        setEnableSwitch(prevState => ({
            ...prevState,
            [type]: true
        }))
    }
    const onLoadContact = async () => {
        onShowLoading(true);
        try {
            let result = await crmservices.contacts.getContact();
            if (result.code === 'OK') {
                let sms_opt_out = result.data.sms_opt_out ? false : true;
                let email_opt_out = result.data.email_opt_out ? false : true;
                setSmsOtpOut(sms_opt_out);
                setEmailOtpOut(email_opt_out);
                //await cache.setContact(result.data);
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
        onShowLoading(false);
    }
    const onChangeLanguage = async (language) => {
        setCurrentLanguage(language)
        saveDataIntoAsyncStore('LANGUAGE', language);
        i18n.changeLanguage(language);
        crmservices.contacts.updateContactLanguage(language);
    }

    const onDeleteUser = async () => {
        setShowConfirmDeleteUser(false);
        onShowLoading(true);
        try {
            const result = await crmservices.contacts.deleteContact();
            setConfirm({});
            if (result.code == 'OK') {
                props.onClose();
                await logOut();
            } else if (result.code == 'CANNOTUNREGISTERCONTACTEXCEPTION') {
                let parameters = result.data.parameters && result.data.parameters.length > 0 ? result.data.parameters[0] : null;
                if (parameters == 'Contact has active subscription service') {
                    showAlert({ status: true, title: t('ERROR'), message: t('UNREGISTER_CONTACT_EXCEPTION_ACTIVE_SUB') });
                } else if (parameters == 'Contact has rented devices') {
                    showAlert({ status: true, title: t('ERROR'), message: t('UNREGISTER_CONTACT_EXCEPTION_RENTED_DEVICE') });
                } else if (parameters == 'Contact has incomplete order') {
                    showAlert({ status: true, title: t('ERROR'), message: t('UNREGISTER_CONTACT_EXCEPTION_INCOMPLETE_ORDER') });
                } else if (parameters == 'Contact has unpaid account balance') {
                    showAlert({ status: true, title: t('ERROR'), message: t('UNREGISTER_CONTACT_EXCEPTION_UNPAID_ACCOUNT') });
                } else {
                    showAlert({ status: true, title: t('ERROR'), message: t('EXCEPTION_PROCESS') });
                }
            } else {
                showAlert({ status: true, title: t('ERROR'), message: t('EXCEPTION_PROCESS') });
            }
        } catch (ex) {
            showAlert({ status: true, title: t('ERROR'), message: t('EXCEPTION_PROCESS') });
        }
        onShowLoading(false);
    }

    const setShowConfirmDeleteUser = () => {
        setConfirm({
            show: true,
            title: t('unregister'),
            message: t('unregister_confirm'),
            onAction: () => onDeleteUser(),
        })
    }

    const showAlert = ({message, status, title, close}) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            message: message,
            status: status,
            title: title,
            close: close
        });
    }

    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            message: '',
            status: '',
            close: true
        });
    }

    return (
        <div>
            <SettingsView
                showLoading={showLoading}
                open={props.open}
                onClose={props.onClose}
                email_opt_out={email_opt_out}
                sms_opt_out={sms_opt_out}
                app_name={app_name}
                languages={languages}
                onUpdateMarketingInformation={onUpdateMarketingInformation}
                onChangeLanguage={onChangeLanguage}
                currentLanguge={currentLanguge}
                setShowConfirmDeleteUser={setShowConfirmDeleteUser}
            />
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
            />
            {confirm && <ModalConfirm
                open={confirm.show}
                onClose={confirm.onAction}
                message={confirm.message}
                confirm={t('no')}
                buttonLabel={t('yes')}
                onAction={() => setConfirm({})}
            />}
        </div>
    );
}

export default SettingsController;